//initial test database used for testing purposes in the beginning


//import image from './assets/0004-0005-050.jpg'
//import image2 from './assets/Kleid_LOLA_blau_VT.jpg'
//import image3 from './assets/0008-0018-050.jpg'
//import image4 from './assets/0022-0004-010.png'

const sizes = {
    sizes: [
        { size: "Hemden", sizeEntries: ["XS", "S", "M", "L", "XL"] },
        { size: "Hosen", sizeEntries: ["32", "34", "36", "38"] }
    ]
}


const inventory = [
        {
            articleType: "Hemden",
            articleEntries: [
                {
                    articleEntry: "Hemd Tobias",
                    //articleImage: image,
                    price: parseFloat('20.00').toFixed(2).replace('.', ','),
                    articleNumber: 7452,
                    style: "",
                    gender: "Männlich",
                    sizeEntries: [
                        {
                            sizeEntry: "XS", amount: 2
                        },
                        {
                            sizeEntry: "S", amount: 4
                        },
                        {
                            sizeEntry: "M", amount: 10
                        },
                        {
                            sizeEntry: "L", amount: 10
                        },
                        {
                            sizeEntry: "XL", amount: 3
                        },
                    ]
                },
                {
                    articleEntry: "Hemd Ingo",
                    //articleImage: image2,
                    price: parseFloat('25.00').toFixed(2).replace('.', ','),
                    articleNumber: 8552,
                    style: "",
                    gender: "Männlich",
                    sizeEntries: [
                        {
                            sizeEntry: "XS", amount: 2
                        },
                        {
                            sizeEntry: "S", amount: 14
                        },
                        {
                            sizeEntry: "M", amount: 9
                        },
                        {
                            sizeEntry: "L", amount: 4
                        },
                        {
                            sizeEntry: "XL", amount: 0
                        },
                    ]
                }
            ]
        },
        {
            articleType: "Hosen",
            articleEntries: [
                {
                    articleEntry: "Hose Lila",
                    //articleImage: image3,
                    price: parseFloat('34.99').toFixed(2).replace('.', ','),
                    articleNumber: 8452,
                    gender: "Weiblich",
                    style: "Lila gefärbte Hose mit Streifen",
                    sizeEntries: [
                        {
                            sizeEntry: "32", amount: 0
                        },
                        {
                            sizeEntry: "34", amount: 0
                        },
                        {
                            sizeEntry: "36", amount: 22
                        },
                        {
                            sizeEntry: "38", amount: 8
                        },
                    ]
                },
                {
                    articleEntry: "Hose Grün",
                    //articleImage: image4,
                    price: parseFloat('36.95').toFixed(2).replace('.', ','),
                    articleNumber: 1855,
                    style: "",
                    gender: "Junge",
                    sizeEntries: [
                        {
                            sizeEntry: "32", amount: 5
                        },
                        {
                            sizeEntry: "34", amount: 7
                        },
                        {
                            sizeEntry: "36", amount: 2
                        },
                        {
                            sizeEntry: "38", amount: 12
                        },
                    ]
                }
            ]
        }
    ]

const newArticleType = [
    {
        sizeCat: "Test",
        articleNumber: 1234,
        price: 20,
        name: "TestName"
    }
]

const initialState = {
    inventory: inventory,
    sizes: sizes
};

export default initialState